import React from "react";
import { Segment } from "semantic-ui-react";

import * as styles from "./colored-section.module.css";

export const ColoredSection = ({ children }) => (
  <Segment
    basic
    className={styles.section}
   
  >
  <div className={styles.child} />
    {children}
  </Segment>
);


